import axios from "axios";

export const API = axios.create({
  baseURL:
    "https://ulmdgk1h0a.execute-api.us-east-1.amazonaws.com/staging/v1.0",
  timeout: 10000
});
